import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Shell from "@/components/Shell";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import AcceptInvitation from "@/pages/AcceptInvitation";
import Onboarding from "@/pages/Onboarding";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/ScopedDashboard";
import Pipeline from "@/pages/Pipeline";
import Tasks from "@/pages/Tasks";
import BusinessDetail from "@/pages/BusinessDetail";
import LeadDetail from "@/pages/LeadDetail";
import ContractDetail from "@/pages/ContractDetail";
import OpportunityDetail from "@/pages/OpportunityDetail";
import Calendar from "@/pages/Calendar";
import Reports from "@/pages/Reports";
import Commissions from "@/pages/Commissions";
import Advertisers from "@/pages/Advertisers";
import Renewals from "@/pages/Renewals";
import Users from "@/pages/Users";
import Integrations from "@/pages/Integrations";
import Settings from "@/pages/Settings";
import Activities from "@/pages/Activities";
import TerritoriesZones from "@/pages/TerritoriesZones";
import HostBusinesses from "@/pages/HostBusinesses";
import AdminControlCenter from "@/pages/AdminControlCenter";
import DocumentLibrary from "@/pages/DocumentLibrary";
import MyResources from "@/pages/MyResources";
import Composer from "@/pages/Composer";
import CrudResource from "@/components/CrudResource";
import RequireRole from "@/components/RequireRole";

const ADMIN = ["tenant_owner", "platform_owner"];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/accept-invitation" element={<AcceptInvitation />} />
          <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
          <Route element={<ProtectedRoute><Shell /></ProtectedRoute>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Navigate to="/" replace />} />
            <Route path="/leads" element={<CrudResource resourceKey="leads" />} />
            <Route path="/leads/:id" element={<LeadDetail />} />
            <Route path="/host-businesses" element={<HostBusinesses />} />
            <Route path="/businesses" element={<CrudResource resourceKey="businesses" />} />
            <Route path="/businesses/:id" element={<BusinessDetail />} />
            <Route path="/contacts" element={<CrudResource resourceKey="contacts" />} />
            <Route path="/pipeline" element={<Pipeline />} />
            <Route path="/opportunities/:id" element={<OpportunityDetail />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/composer" element={<Composer />} />
            <Route path="/resources" element={<MyResources />} />
            <Route path="/advertisers" element={<Advertisers />} />
            <Route path="/contracts" element={<CrudResource resourceKey="contracts" />} />
            <Route path="/contracts/:id" element={<ContractDetail />} />
            <Route path="/renewals" element={<Renewals />} />
            <Route path="/commissions" element={<Commissions />} />
            <Route path="/territories" element={<TerritoriesZones />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/users" element={<RequireRole roles={ADMIN}><Users /></RequireRole>} />
            <Route path="/admin" element={<RequireRole roles={ADMIN}><AdminControlCenter /></RequireRole>} />
            <Route path="/documents" element={<RequireRole roles={ADMIN}><DocumentLibrary /></RequireRole>} />
            <Route path="/integrations" element={<RequireRole roles={ADMIN}><Integrations /></RequireRole>} />
            <Route path="/settings" element={<RequireRole roles={ADMIN}><Settings /></RequireRole>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
